import React, { FunctionComponent } from 'react';
import { TreeItem, TreeView } from '@mui/lab';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import {
  Close as CloseIcon,
  ExpandMore as ExpandMoreIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';

import { ILessonHistoryParticipantAttendance } from '../../../../../store/V2/LessonHistorySlice';

interface ViewAttendanceHistoryModalProps {
  open: boolean;
  onClose: () => void;
  list: ILessonHistoryParticipantAttendance[];
}

const ViewAttendanceHistoryModal: FunctionComponent<ViewAttendanceHistoryModalProps> = ({
  open,
  onClose,
  list = [],
}) => {
  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { borderRadius: '20px', maxWidth: '800px' },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: { xs: '15px', sm: '30px' },
          color: '#000000',
          fontWeight: 600,
          fontSize: '16px',
        }}
      >
        Attendance
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: { xs: '7px', sm: '22px' },
          top: { xs: '7px', sm: '22px' },
        }}
      >
        <CloseIcon sx={{ color: '#000000' }} />
      </IconButton>
      <DialogContent sx={{ p: { xs: '0 15px', sm: '0 30px' } }}>
        <div>
          <TreeView
            aria-label="file system navigator"
            defaultCollapseIcon={<ExpandMoreIcon />}
            defaultExpandIcon={<ChevronRightIcon />}
          >
            {list.map((attendanceHistory, index) => (
              <TreeItem
                key={index}
                nodeId={index.toString()}
                label={`${attendanceHistory.name}     -     ( ${new Date(
                  attendanceHistory.join_time
                ).toLocaleString('en-US', { timeZoneName: 'short' })} )`}
                style={{ marginBottom: '20px' }}
              >
                <TreeItem
                  nodeId={attendanceHistory.id}
                  label={
                    <pre>{JSON.stringify(attendanceHistory, null, 2)}</pre>
                  }
                />
              </TreeItem>
            ))}
          </TreeView>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewAttendanceHistoryModal;
